import {Component, Injectable, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/switchMap';
import {AuthService} from '../../../authentication/services/auth.service';
import {AlertService} from '../../../shared/alert/services/alert.service';
import {SideBarService} from '../../../shared/services/sideBarService';
import {UrlService} from '../../../shared/services/url.service';
import {GlobalAlert} from '../../models';
import {GlobalAlertService} from '../../services/globalalert.service';
import {GlobalAlertMainComponent} from './main.component';
import {TagModel} from 'ngx-chips-4x/core/accessor';
import {mapToCountryTagModelArray} from '../../../brokers/components/scripts/broker-model-utils';
import {CountryService} from '../../../brokers/services/country.service';
import {ButtonToggleGroupOption} from '../../../shared/models/buttonToggleGroupOption';
import {GealocalicationAction} from '../../models/globalalert';

@Component({
  selector: 'app-globalalert',
  templateUrl: '../templates/globalalert.component.html',
  styleUrls: [ '../styles/globalalert.component.scss' ],
})
@Injectable()
export class GlobalAlertComponent extends GlobalAlertMainComponent implements OnInit {
  @Input() globalAlertModel: GlobalAlert;
  DashboardUrl: string;
  SelectedLanguageIsoCode: string;
  SelectedCountries: any[] = [];
  AutocompleteCountries: TagModel[];
  CountrySelectorPlaceholder = '';
  DefaultGeolocationAction = GealocalicationAction.NoAction;
  GeolocationAction = this.DefaultGeolocationAction;
  IsCountrySelectorDisabled = this.GeolocationAction === GealocalicationAction.NoAction;
  GeolocationButtonToggleOptions: ButtonToggleGroupOption<GealocalicationAction>[] = [
  {
    label: 'No Action',
    value: GealocalicationAction.NoAction,
    customStyles: { backgroundColor: '#b0bec5', color: 'white' }
  },
  {
    label: 'Ban',
    value: GealocalicationAction.Ban,
    customStyles: { backgroundColor: '#e57373', color: 'white' }
  },
  {
    label: 'Whitelist',
    value: GealocalicationAction.Whitelist,
    customStyles: { backgroundColor: '#66bb6a', color: 'white' }
  }
];

  constructor(
    private globalAlertService: GlobalAlertService,
    private countryService: CountryService,
    private alertService: AlertService,
    private urlService: UrlService,
    private authService: AuthService,
    sideBarService: SideBarService
  ) {
    super(sideBarService);

    this.globalAlertModel = {} as GlobalAlert;

    this.DashboardUrl = this.urlService.GetDashboardRoute();
    this.SelectedLanguageIsoCode = this.authService.getActualLanguage().cultureNameISO;
  }

  ngOnInit() {
    this.initModel();
    this.initGeolocationActionWith(this.GeolocationAction);

    super.ngOnInit();
  }

  public Send(form: FormGroup) {
    this.alertService.removeAll();
    let Title = form.value.Title || '';
    const maxChars = 160;
    if (Title.includes('</i>')) {
      Title = Title.replace(/<[^>]*>/g, '');
    }
    const TitleLength = Title.length;
    if (Title.length > maxChars) {
      this.alertService.add('danger', `Title require fewer characters. Max allowed ${maxChars}, introduced ${TitleLength}.`);
      return;
    }
    if (!form.valid) {
      this.alertService.add('danger', 'There are some errors in the form. Check required fields.');
      return;
    }

    const isBanOrWhitelisted =
      this.GeolocationAction === GealocalicationAction.Ban ||
      this.GeolocationAction === GealocalicationAction.Whitelist;
    const isSelectedCountriesEmpty = this.SelectedCountries.length <= 0;

    if (isBanOrWhitelisted && isSelectedCountriesEmpty) {
      this.alertService.add('danger', 'You must selected at least one country');
      return;
    }

    if (isBanOrWhitelisted) {
      this.globalAlertModel.Geolocation = {
        Action: this.GeolocationAction,
        Countries: this.SelectedCountries.map(sc => sc.value)
      };
    } else {
      this.globalAlertModel.Geolocation = undefined;
    }

    this.globalAlertService.Send(this.globalAlertModel).subscribe(
      (data) =>
        this.alertService.add('success', 'Global alert successfully sent.'),
      (err) =>
        this.alertService.add('danger', 'Send global alert error: ' + err)
    );
  }

  initGeolocationActionWith(value: GealocalicationAction) {
    this.DefaultGeolocationAction = value;
    this.onGeolocationActionChange(value);
  }

  onGeolocationActionChange(value: GealocalicationAction) {
    if (value === GealocalicationAction.NoAction) {
      this.disableCountrySelector();
      this.setCountrySelectorPlaceholder('Disabled');
    } else if (value === GealocalicationAction.Ban) {
      this.enableCountrySelector();
      this.setCountrySelectorPlaceholder('+ Banned Country');
    } else if (value === GealocalicationAction.Whitelist) {
      this.enableCountrySelector();
      this.setCountrySelectorPlaceholder('+ Whitelisted Country');
    } else {
      console.error(`Casuistry not implemented for GealocalicationAction ${value}`);
    }
  }

  private disableCountrySelector() {
    this.IsCountrySelectorDisabled = true;
  }

  private enableCountrySelector() {
    this.IsCountrySelectorDisabled = false;
  }

  private setCountrySelectorPlaceholder (value: string) {
    this.CountrySelectorPlaceholder = value;
  }

  private initModel() {
    this.countryService.GetCountries().subscribe(countries => {
      this.AutocompleteCountries = mapToCountryTagModelArray(countries);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/editorialtools/components/scripts/globalalert.component.ts